import { useCatalog } from '~/hooks/use-catalog';
import { serializeProductOrKit } from '~/utils/serialize';
import useCustomAnalytics from './use-custom-analytics';
import { useMemo } from 'react';
import useSiteMetadataQuery from '~/hooks/graphql/queries/use-site-metadata';
import { useAnalytics } from '@chordcommerce/react-autonomy';

/* 
Put this hook on top level of product component,
product slug will pull all information available about product from the selectors.
*/
const useProductAnalytics = (productSlug) => {
  const { track } = useCustomAnalytics();
  const { trackProductViewed: chordTrackProductViewed, trackVariantClicked: chordTrackVariantClicked } = useAnalytics();

  const { findProductBySlug } = useCatalog();
  const foundProduct = useMemo(() => findProductBySlug(productSlug), [productSlug]);
  const { site } = useSiteMetadataQuery() ?? {};

  const trackProductClicked = ({ locationDetail, collection }, data = {}) => {
    const url = `${site?.siteMetadata?.siteUrl}/${collection}/${productSlug}/`;

    const serializedProduct = serializeProductOrKit(foundProduct, '', { url, locationDetail, ...data });
    // Using custom version since it can send additional information up in the event. The chord version is unused.
    track('Product Clicked', {
      ...serializedProduct,
    });
  };

  const trackProductViewed = ({ locationDetail, collection }, data = {}) => {
    const url = `${site?.siteMetadata?.siteUrl}/${collection}/${productSlug}/`;
    const serializedProduct = serializeProductOrKit(foundProduct, '', { url, locationDetail, ...data });
    chordTrackProductViewed({ product: serializedProduct });
  };

  const trackVariantClicked = ({ locationDetail, sku, collection }) => {
    const url = `${site?.siteMetadata?.siteUrl}/${collection}/${productSlug}/`;
    const serializedProduct = serializeProductOrKit(foundProduct, sku, { url, locationDetail });
    chordTrackVariantClicked({ product: serializedProduct });
  };

  return { trackProductClicked, trackProductViewed, trackVariantClicked };
};

export default useProductAnalytics;
